module.exports = __webpack_public_path__ + "img/suppliers.ad1aa23b.png";